import styled from 'styled-components'
import { Box } from '@usap/uicomponents'

export const OtherPaymentOptionsContainer = styled(Box)`
  text-align: center;
  align-items: center;
`
export const OtherPaymentOptionsLabel = styled(Box)`
  color: #282832;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin: 20px 0;
  position: relative;
  padding: 0 8px;
  background-color: white;
  z-index: 1;
  white-space: nowrap; 
`
export const OtherPaymentOptionsWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%
`
export const OtherPaymentOptionsDivider = styled.div`
  display: none;

  @media only screen and (max-width: 768px) {
    position: absolute;
    width: 100%;
    height: 2px;
    background-color: #D4D4D6;
    display: block;
  }
`